import React from "react";
import {
  Box,
  CardContent,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";

const PaymentBillingSettings = () => {
  const navigate = useNavigate();

  const settings = [
    {
      title: "Payment Methods",
      description:
        "Add or update your preferred payment options — including credit/debit cards, PayPal, or bank transfers.",
      section: "payment-methods", // 👈 section value for navigation
    },
    {
      title: "Transaction History",
      description:
        "View a complete record of payments, payouts, refunds, and invoices linked to your account.",
      section: "transaction-hisotry",
    },
    {
      title: "Subscription & Plans",
      description:
        "Check your current plan status, track usage limits, and manage plan upgrades, downgrades, or cancellations.",
      section: "subscription",
    },
  ];

  const handleNavigate = (section) => {
    navigate("/settings", { state: { section } });
  };

  return (
    <Box
      p={3}
      sx={{
        width: "100%",
        height: "100vh",
        borderRadius: 2,
        border: "1px solid rgba(221, 221, 221, 1)",
        boxShadow: 0,
        backgroundColor: "#fff",
        mt: 2
      }}
    >
      <CardContent sx={{ p: 0 }}>
        {settings.map((item, index) => (
          <Box key={index}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              px={1}
              py={2}
              sx={{
                cursor: "pointer",
                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.02)" },
              }}
              onClick={() => handleNavigate(item.section)} // ✅ Navigate on click
            >
              <Box pr={2} flexGrow={1}>
                <Typography fontWeight={600}>{item.title}</Typography>
                <Typography variant="body2" color="text.secondary" mt={0.5}>
                  {item.description}
                </Typography>
              </Box>
              <IconButton
                size="small"
                disableRipple
                sx={{
                  p: 0,
                  border: "none !important",
                  background: "transparent",
                  "&:hover": { background: "transparent" },
                }}
              >
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>
            </Box>
            {index !== settings.length - 1 && <Divider />}
          </Box>
        ))}
      </CardContent>
    </Box>
  );
};

export default PaymentBillingSettings;
